import {client} from '@core/GraphQLProvider';
import {
    CreateWebLoginForExistingCustomer,
    RegisterNewCustomer,
    ValidateAddress,
    CheckIfExistingCustomer,
    VerifyAccountByInvoice,
    GetCitiesFromPostalCode
} from './query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

// todo: add null/validation to all endpoints

const RegistrationService = {

    verifyAccount: ( {accountNumber, invoiceId} = {} ) => {
        return RegistrationService.verifyByAccountAndInvoice( accountNumber, invoiceId );
    },

    createWebLoginForExistingCustomer: async ( {input, update} ) => {
        return client.mutate( {
            mutation: CreateWebLoginForExistingCustomer,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( 'TODO - Update cache for RegisterExistingUser mutation' );
            })
        } );
    },

    registerNewCustomer: async ( {input, update} ) => {
        return client.mutate( {
            mutation: RegisterNewCustomer,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( 'TODO - Update cache for RegisterNewUser mutation' );
            })
        } );
    },

    validateAddress: async ( {address} ) => {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: ValidateAddress,
            variables: {address}
        } );
        return resp.data.validateAddress;
    },

    checkIfExistingCustomer: async ( email, dentalLicense ) => {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: CheckIfExistingCustomer,
            variables: {emailAddress: email, dentalLicense}
        } );
        return resp.data.checkIfExistingCustomer;
    },

    verifyByAccountAndInvoice: async ( accountNumber, invoiceId ) => {
        const resp = await client.query( {
            fetchPolicy: 'no-cache',
            query: VerifyAccountByInvoice,
            variables: {accountNumber, invoiceId}
        } );
        return resp.data.addressesByAccountAndInvoice;
    },

    getCitiesFromPostalCode: async ( postalCode ) => {
        const resp = await client.query( {
            query: GetCitiesFromPostalCode,
            variables: {postalCode}
        } );

        return resp.data.postalCodeInfo;
    }
};

export default RegistrationService;

